import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  RefreshCw,
  Search,
  X,
} from "lucide-react";

const PhysicalStockEntryTable = (props) => {
  const { data = [], loading } = props; // Default to empty array if data is undefined

//   const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  // Filter data based on search term
  const filteredData = data.filter((row) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      row.code?.toLowerCase().includes(searchLower) ||
      row.desc?.toLowerCase().includes(searchLower) ||
      row.unit?.toLowerCase().includes(searchLower) ||
      row.CATEGORY?.toLowerCase().includes(searchLower) ||
      row.SUBGROUP?.toLowerCase().includes(searchLower) ||
      row.grp?.toLowerCase().includes(searchLower) ||
      row.bin?.toLowerCase().includes(searchLower)
    );
  });

  // Update totalItems based on filtered data
  const totalItems = filteredData.length;

  // Calculate pagination
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  // Reset to page 1 when data or search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [data, searchTerm]);

  // Reset to page 1 when items per page changes
  useEffect(() => {
    setCurrentPage(1);
  }, [itemsPerPage]);

  const loadData = () => {
    // Trigger a refresh in parent component if needed
    if (props.onRefresh) {
      props.onRefresh();
    }
  };

  // Pagination handlers
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const goToFirstPage = () => setCurrentPage(1);
  const goToLastPage = () => setCurrentPage(totalPages);
  const goToPreviousPage = () => goToPage(currentPage - 1);
  const goToNextPage = () => goToPage(currentPage + 1);

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }

    return pages;
  };

  const calculateVariation = (qty, phyqty) => {
    return (phyqty - qty).toFixed(2);
  };

//   // Calculate total variation for ALL filtered data
//   const totalVariation = filteredData.reduce((sum, row) => {
//     const variation = parseFloat(calculateVariation(row.QTY, row.phyqty));
//     return sum + variation;
//   }, 0);

  // Calculate variation for current page only
  const currentPageVariation = currentData.reduce((sum, row) => {
    const variation = parseFloat(calculateVariation(row.QTY, row.phyqty));
    return sum + variation;
  }, 0);

  // Clear search
  const clearSearch = () => {
    setSearchTerm("");
  };

  const totalVariation = React.useMemo(() => {
    console.log("Calculating total variation..."); // For debugging performance
    return data
      .reduce((sum, row) => {
        return sum + row.total;
      }, 0)
      .toFixed(2);
  }, [data]);

  return (
    <div className="w-full">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
       

        {/* Total Variation Summary */}
        {/* <div className="mb-4 pb-4 border-b border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg p-4 border border-blue-200">
              <div className="text-sm font-semibold text-gray-600 mb-1">
                {searchTerm ? "Filtered Items" : "Total Items"}
              </div>
              <div className="text-2xl font-bold text-blue-700">
                {totalItems}
              </div>
              {searchTerm && (
                <div className="text-xs text-gray-500 mt-1">
                  of {data.length} total
                </div>
              )}
            </div>
            <div
              className={`bg-gradient-to-r rounded-lg p-4 border ${
                totalVariation > 0
                  ? "from-green-50 to-green-100 border-green-200"
                  : totalVariation < 0
                  ? "from-red-50 to-red-100 border-red-200"
                  : "from-gray-50 to-gray-100 border-gray-200"
              }`}
            >
              <div className="text-sm font-semibold text-gray-600 mb-1">
                {searchTerm
                  ? "Filtered Total Variation"
                  : "Total Variation (All Data)"}
              </div>
              <div
                className={`text-2xl font-bold ${
                  totalVariation > 0
                    ? "text-green-700"
                    : totalVariation < 0
                    ? "text-red-700"
                    : "text-gray-700"
                }`}
              >
                {totalVariation > 0 ? "+" : ""}
                {totalVariation.toFixed(2)}
              </div>
            </div>
            <div
              className={`bg-gradient-to-r rounded-lg p-4 border ${
                currentPageVariation > 0
                  ? "from-green-50 to-green-100 border-green-200"
                  : currentPageVariation < 0
                  ? "from-red-50 to-red-100 border-red-200"
                  : "from-gray-50 to-gray-100 border-gray-200"
              }`}
            >
              <div className="text-sm font-semibold text-gray-600 mb-1">
                Current Page Variation
              </div>
              <div
                className={`text-2xl font-bold ${
                  currentPageVariation > 0
                    ? "text-green-700"
                    : currentPageVariation < 0
                    ? "text-red-700"
                    : "text-gray-700"
                }`}
              >
                {currentPageVariation > 0 ? "+" : ""}
                {currentPageVariation.toFixed(2)}
              </div>
            </div>
          </div>
        </div> */}

        {/* Items per page selector */}
        <div className="flex items-center gap-3">
          <label className="text-sm font-semibold text-gray-700">
            Items per page:
          </label>
          <select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
            }}
            className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 bg-white text-gray-700 cursor-pointer"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span className="text-sm text-gray-600">
            Showing {totalItems > 0 ? startIndex + 1 : 0} to{" "}
            {Math.min(endIndex, totalItems)} of {totalItems} entries
          </span>

          <div className="bg-cyan-50 px-4 py-2 rounded-lg border border-cyan-100">
            <span className="text-sm font-medium text-gray-600 mr-2">
              Total Variation Value:
            </span>
            <span
              className={`text-lg font-bold ${
                totalVariation > 0
                  ? "text-green-600"
                  : totalVariation < 0
                  ? "text-red-600"
                  : "text-gray-700"
              }`}
            >
              {totalVariation}
            </span>
          </div>

          {/* {props.onRefresh && (
            <button
              onClick={loadData}
              disabled={loading}
              className="ml-auto px-4 py-2 bg-cyan-600 text-white font-semibold rounded-lg hover:bg-cyan-700 transition-colors disabled:bg-gray-400 flex items-center gap-2"
            >
              <RefreshCw
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
              Refresh
            </button>
          )} */}
        </div>
      </div>

       {/* Search Bar */}
       <div className="mb-4 flex">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by Code, Description, Category, Unit, Bin, Group..."
              className="pl-10 pr-10 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent text-gray-700"
            />
            {searchTerm && (
              <button
                onClick={clearSearch}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            )}
          </div>
          {searchTerm && (
            <p className="text-sm text-gray-600 mt-2">
              Found {totalItems} result{totalItems !== 1 ? "s" : ""} for "
              {searchTerm}"
            </p>
          )}
        </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
        <div className="overflow-x-auto overflow-y-auto max-h-[300px]">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-cyan-500 to-cyan-600 sticky top-0 z-10">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  S.No
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  CODE
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  Description
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  Unit
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-white border-r border-cyan-400">
                  System Qty
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-white border-r border-cyan-400">
                  Physical Qty
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-white border-r border-cyan-400">
                  Variation
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-white border-r border-cyan-400">
                  Unit Cost
                </th>
                <th className="px-4 py-3 text-right text-sm font-bold text-white border-r border-cyan-400">
                  Value
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  Bin
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  Group
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-cyan-400">
                  SubGroup
                </th>
                <th className="px-4 py-3 text-left text-sm font-bold text-white">
                  Category
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={12}
                    className="px-4 py-12 text-center text-gray-500"
                  >
                    <RefreshCw className="w-8 h-8 animate-spin mx-auto mb-2" />
                    Loading...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((row, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-cyan-50" : "bg-white"
                    } hover:bg-cyan-100 transition-colors`}
                  >
                    <td className="px-4 py-3 text-sm border-r border-gray-200">
                      {startIndex + index + 1}
                    </td>
                    <td className="px-4 py-3 text-sm font-semibold text-cyan-700 border-r border-gray-200">
                      {row.code}
                    </td>
                    <td className="px-4 py-3 text-sm border-r border-gray-200 max-w-md">
                      <div className="truncate" title={row.descr}>
                        {row.desc}
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm border-r border-gray-200">
                      {row.unit}
                    </td>
                    <td className="px-4 py-3 text-sm text-right border-r border-gray-200">
                      <span
                        className={
                          row.sys_qty < 0 ? "text-red-600 font-semibold" : ""
                        }
                      >
                        {row.sys_qty?.toFixed(2)}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-right border-r border-gray-200">
                      {row.phy_qty?.toFixed(2)}
                    </td>
                    <td className="px-4 py-3 text-sm text-right border-r border-gray-200">
                      <span
                        className={
                            row.variation > 0
                            ? "text-green-600 font-semibold"
                            : row.variation < 0
                            ? "text-red-600 font-semibold"
                            : ""
                        }
                      >
                        {row.variation}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-right border-r border-gray-200">
                      {row.unitcost?.toFixed(3) || "0.000"}
                    </td>
                    <td className="px-4 py-3 text-sm text-right border-r border-gray-200">
                      {row.total?.toFixed(3) || "0.000"}
                    </td>
                    <td className="px-4 py-3 text-sm border-r border-gray-200">
                      {row.bin || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm border-r border-gray-200">
                      {row.grp || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm border-r border-gray-200">
                      {row.SUBGROUP || "-"}
                    </td>
                    <td className="px-4 py-3 text-sm">{row.CATEGORY || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={12}
                    className="px-4 py-12 text-center text-gray-500"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="bg-white rounded-lg shadow-md p-4">
          <div className="flex items-center justify-between">
            {/* Page info */}
            <div className="text-sm text-gray-600">
              Page{" "}
              <span className="font-semibold text-cyan-600">{currentPage}</span>{" "}
              of{" "}
              <span className="font-semibold text-cyan-600">{totalPages}</span>
            </div>

            {/* Pagination buttons */}
            <div className="flex items-center gap-2">
              {/* First page */}
              <button
                onClick={goToFirstPage}
                disabled={currentPage === 1}
                className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                title="First page"
              >
                <ChevronsLeft className="w-4 h-4" />
              </button>

              {/* Previous page */}
              <button
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                title="Previous page"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>

              {/* Page numbers */}
              <div className="flex gap-1">
                {getPageNumbers().map((page, index) => (
                  <React.Fragment key={index}>
                    {page === "..." ? (
                      <span className="px-3 py-2 text-gray-400">...</span>
                    ) : (
                      <button
                        onClick={() => goToPage(page)}
                        className={`px-4 py-2 rounded-lg font-semibold transition-colors ${
                          currentPage === page
                            ? "bg-cyan-600 text-white"
                            : "border border-gray-300 hover:bg-gray-50 text-gray-700"
                        }`}
                      >
                        {page}
                      </button>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Next page */}
              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                title="Next page"
              >
                <ChevronRight className="w-4 h-4" />
              </button>

              {/* Last page */}
              <button
                onClick={goToLastPage}
                disabled={currentPage === totalPages}
                className="p-2 border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                title="Last page"
              >
                <ChevronsRight className="w-4 h-4" />
              </button>
            </div>

            {/* Go to page input */}
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-600">Go to:</span>
              <input
                type="number"
                min={1}
                max={totalPages}
                value={currentPage}
                onChange={(e) => {
                  const page = parseInt(e.target.value);
                  if (page >= 1 && page <= totalPages) {
                    goToPage(page);
                  }
                }}
                className="w-16 px-2 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-center"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhysicalStockEntryTable;
